import { DataPointTemplate, FileDataProgress, UserInteractionStatus, WranglerItem } from "fileParsing/wrangler/types";
import { AppDispatch } from "index";
import { action } from "typesafe-actions";
import { WranglerActionTypes } from "./types";

export function addNewData(exportId: number, items: WranglerItem[]) {
  return (dispatch: AppDispatch) => {
    dispatch(action(WranglerActionTypes.ADD_DATA, { exportId, items }));
  };
}

export function updateData(id: number, template: DataPointTemplate, index?: number) {
  return (dispatch: AppDispatch) => {
    dispatch(action(WranglerActionTypes.UPDATE_DATA, { id, template, index }));
  };
}

export function updateStatus(
  id: number,
  userStatus?: UserInteractionStatus,
  dataProgress?: Partial<FileDataProgress>,
  compiled = false,
) {
  return (dispatch: AppDispatch) => {
    dispatch(
      action(WranglerActionTypes.UPDATE_STATUS, {
        id,
        userStatus,
        dataProgress,
        compiled,
      }),
    );
  };
}

export function removeExport(id: number) {
  return (dispatch: AppDispatch) => {
    dispatch(action(WranglerActionTypes.REMOVE_EXPORT, { id }));
  };
}
